/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
 
import React, { PropsWithChildren } from 'react';

import { isMobile } from '../../utils';

import s from './index.module.less';

interface SignFrameProps {
  brandNode: React.ReactNode;
}

export const SignFrame: React.FC<PropsWithChildren<SignFrameProps>> = ({
  children,
  brandNode,
}) => (
  <div className={isMobile() ? s['mobile-frame'] : s.frame}>
    {!isMobile() && <div className={s.brand}>{brandNode}</div>}
    {children}
  </div>
);
